import { render, staticRenderFns } from "./DelUseLog.vue?vue&type=template&id=9d478f4c&scoped=true&"
import script from "./DelUseLog.vue?vue&type=script&lang=js&"
export * from "./DelUseLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d478f4c",
  null
  
)

export default component.exports